import * as React from 'react';
import Box from '../../../parts/Box';
import MenuBox from '../../../parts/MenuBox';
import {IInputComponentPropsData, IInputComponentPropsFunctions} from '../props/IInputComponentProps';
import {IInputSequenceComponentPropsData, IInputSequenceComponentPropsFunctions} from '../props/IInputSequenceComponentProps';
import {IInputStructureComponentPropsData, IInputStructureComponentPropsFunctions} from '../props/IInputStructureComponentProps';

import InputSequenceContainer from "../containers/InputSequenceContainer";
import InputStructureContainer from "../containers/InputStructureContainer";

import {toolName, examplePDB, exampleSeq} from "../../../settings";

import InputSequenceComponent from "./InputSequenceComponent";
import InputStructureComponent from "./InputStructureComponent";

import { Container, Col, Button, Row } from 'reactstrap';
import {Helmet} from "react-helmet";

import IDT from "../interfaces/InputDataType";

type IProps = IInputComponentPropsData & IInputComponentPropsFunctions & { history: any }
                & IInputSequenceComponentPropsData & IInputSequenceComponentPropsFunctions 
                & IInputStructureComponentPropsData & IInputStructureComponentPropsFunctions;

// InputComponent state is used to be provided as the context for child components


class InputComponent extends React.Component<IProps> {

    infoRef = React.createRef<HTMLFormElement>();

    componentDidMount() {
        this.props.resetMainState();
    }

    handleSubmit = () => {
        //let valid = this.infoRef.current.reportValidity();
        if((this.props.inputDataType == 0 && ((this.props.selectedMM != null && this.props.selectedMM != "-1")
            || (this.props.selectedChains != null && this.props.selectedChains.length > 0)))
            || this.props.inputDataType == 1 && this.props.sequenceChecked){

                if (typeof this.props.email !== 'string'){
                    alert("Please provide your email, which is now a mandatory field.");
                    return;
                }

                if (!this.props.email.includes('@')){
                    alert("Please provide a valid email!");
                    return;
                }

                this.handleObtainSequence();
                if((this.props.inputDataType == IDT.Structure && this.props.pdbIdField.toLowerCase() == examplePDB.toLowerCase())
                || (this.props.inputDataType == IDT.Sequence && this.props.sequence.toUpperCase() == exampleSeq.toUpperCase())){    

                    if(window.confirm("By clicking on OK button you will be redirected to precalculated results.")){
                        this.props.redirectExample();
                    }
                    else{
                        this.props.submitInput();
                    }
                }
                else{
                    this.props.submitInput();
                }
        }
        else{
            alert("Please provide your structure (and select its biological unit/chains) or the sequence of your protein.");
        }
    } 

    handleTestMessage = () => {
        this.props.testMessage();
    }

    handleObtainSequence = () => {
        this.props.obtainSequence(this.props.jobId, this.props.specifyChainsManually, this.props.selectedMM, this.props.selectedChains, this.props.inputDataType, this.props.sequence);
    }

/* ----------------------------------------------------------------------------------------------------------------------------- */
    render() {
        return <div>

            <Helmet>Input</Helmet>
           
            <Box title = "Select type of input data">

                <Container>
                    <Row>
                    <Col style = {{marginRight : '10px'}} className={ this.props.inputDataType==IDT.Structure ? "grid_box_clicked" : "grid_box"} >
                        <MenuBox title = "STRUCTURE" image="/images/input_data/hw1.png" onClick= {() => this.props.changeInputDataType(IDT.Structure)}></MenuBox>
                    </Col>
                    <Col style = {{marginLeft : '10px'}} className={ this.props.inputDataType==IDT.Sequence ? "grid_box_clicked" : "grid_box"} >
                        <MenuBox title = "SEQUENCE" image="/images/input_data/hw2.png" onClick= {() => this.props.changeInputDataType(IDT.Sequence)}></MenuBox>
                    </Col>
                    </Row>
                </Container>

            </Box>
            { this.props.inputDataType != IDT.Structure ? null :
                <InputStructureContainer {...this.props}/>
            }
            { this.props.inputDataType != IDT.Sequence ? null :
                <InputSequenceContainer { ...this.props}
                    />
            }
            <Box title="Job information">
                    <form id="ll-input-info" ref={this.infoRef}>
                    <div className="form-group">
                        <label htmlFor="inputJobTitle">Job title</label>
                        <input required type="text" className="form-control" id="inputJobTitle"
                            value={this.props.jobTitle}
                            onChange={evt => this.props.changejobTitle(evt.target.value)}
                            //required
                            maxLength={50}
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="inputEmail">Email (required)</label>
                        <input type="email" className="form-control" id="inputEmail"
                            value={this.props.email}
                            onChange={evt => this.props.changeemail(evt.target.value)}
                            minLength={3} // username + @ + domain
                            maxLength={50}
                        />
                    </div>
                    </form>
            </Box>
            <div>
                <Button
                    color="primary"
                    size="lg"
                    onClick={this.handleSubmit}
                >Next</Button>
            </div>

        </div>
    }
    
}

export default InputComponent;
